import { Box, Text } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { FormikProps } from 'formik';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { ReportingPeriod } from '~/packages/creditAgreements/ui/ReportingPeriod';

type FundingRequestMetricsConfigProps = {
  values: CreditAgreement.Config.Reporting.Inputs.DataAccessor.FundingRequestMetricsAccessor;
  formProps: FormikProps<CreditAgreement.Config.Reporting.Inputs.DataAccessor.Accessor>;
};
export const FundingRequestMetricsConfig = ({
  values,
  formProps,
}: FundingRequestMetricsConfigProps) => {
  const { parameterConfig } = values;

  return (
    <Box id="funding-request-metrics-config-container">
      <Box mb="4">
        <Text fontWeight="bold" mb="3">
          Reporting Date Formula
        </Text>
        <Editor
          value={parameterConfig.reportingDateFormula.params.formula}
          onChange={(val) =>
            formProps.setFieldValue(
              'parameterConfig.reportingDateFormula.params.formula',
              val,
            )
          }
          theme="vs-dark"
          width="100%"
          height="100px"
        />
      </Box>

      <ReportingPeriod
        reportingPeriod={parameterConfig.reportingPeriod.params}
        setReportingPeriod={(reportingPeriod) =>
          formProps.setFieldValue(
            'parameterConfig.reportingPeriod.params',
            reportingPeriod,
          )
        }
      />
    </Box>
  );
};
